export const SELECT_SELECTED_OPTION_CLASS = `joykit-select-selected`;
